export const modes = [
    {
        fields: ['transit'],
        label: 'transit'
    }, {
        fields: ['pedestrian'],
        label: 'walking'
    }, {
        fields: ['bicycle'],
        label: 'biking'
    }
]

export const amenities = [
    {
        fields: ['supermarket', 'farmers_markets'],
        label: 'groceries',
        color: '#3b9121'
    }, {
        fields: ['restaurant'],
        label: 'restaurants',
        color: '#e00000'
    }, {
        fields: ['schools'],
        label: 'schools',
        color: '#46b1e2'
    }, {
        fields: ['medical'],
        label: 'healthcare',
        color: '#e740da'
    }, {
        fields: ['recreation'],
        label: 'recreation & greenspace',
        color: '#8947e6'
    }, {
        fields: ['commercial'],
        label: 'retail',
        color: '#ffd95c'
    }, {
        fields: ['entertainment'],
        label: 'entertainment & culture',
        color: '#ff6600'
    }
]
